import { FormViewField } from 'components/FormView';
export default {
  formName: 'PurchaseOrderFilterRow',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
    {
      id: 1,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Supplier',
        name: 'Supplier',
        size: 'small',
        lookupName: 'Supplier',
      }
    },
    {
      id: 2,
      type: 'EX_LOOKUP_FIELD',
      visible: true,
      props: {
        label: 'Entity view',
        name: 'View',
        size: 'small',
        required: true,
        lookupName: 'EntityView'
      }
    },
    {
      id: 3,
      type: 'EX_LOOKUP_FIELD',
      visible: true,
      props: {
        label: 'Warehouse',
        name: 'Entity',
        size: 'small',
        lookupName: 'WarehouseEntity'
      }
    },
    {
      id: 4,
      type: 'AUTOCOMPLETE_FIELD',
      props: {
        label: 'Status',
        name: 'Status',
        required: false,
        apiPrefs: {
          path: '/CustomTypes/Lookup/PurchaseOrderStatus',
          method: 'GET',
          params: {
            BatchSize: 20
          }
        },
      }
    },
    {
      id: 5,
      type: 'SELECT_FIELD',
      props: {
        label: '',
        name: 'Finalised',
        defaultValue: false,
        options: [
          {
            value: false,
            label: 'Unfinalised',
            default: true
          },
          {
            value: true,
            label: 'Finalised'
          }
        ]
      }
    },
  ] as FormViewField[]
};
